// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HeaderMain{background:linear-gradient(180deg,rgba(237,245,253,.5),#edf5fd)}.HeaderMain__contact-info{margin-bottom:1rem}.HeaderMain__contact-info .svg-icon{height:1.5rem;width:1.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
